import { useState } from 'react';

interface IInput {
  name: string;
  label?: string;
  type?: string;
  placeholder?: string;
  rules?: any;
  required?: boolean;
  color?: string;
  onChange?: any;
}

export default function Input({ name, label, type, placeholder, required, color, onChange }: IInput) {
  const [inputType, setType] = useState(type);

  const handleIconClick = () => {
    if (inputType === 'password') {
      setType('text');
    } else {
      setType('password');
    }
  };

  return (
    <div className="flex flex-col">
      {label && (
        <label htmlFor={name} className="mb-2 text-[14.5px] text-6A4E64">
          {label} {required && <span className="text-FF1D30">*</span>}
        </label>
      )}

      <div className="w-full relative">
        <input
          type={inputType}
          placeholder={placeholder}
          className={`border ${color} border-input w-full h-[44px] pl-4 rounded-[40px] focus:outline-none placeholder-input`}
          required={required}
          onChange={onChange}
        />
        {type === 'password' && (
          <img
            onClick={handleIconClick}
            alt="icon-eye"
            src="/assets/images/eye.svg"
            className="absolute right-3 top-3 cursor-pointer"
          />
        )}
      </div>
    </div>
  );
}
